import { render, staticRenderFns } from "./CompactEditComplexLookupComponent.vue?vue&type=template&id=0f54d934&scoped=true&"
import script from "./CompactEditComplexLookupComponent.vue?vue&type=script&lang=js&"
export * from "./CompactEditComplexLookupComponent.vue?vue&type=script&lang=js&"
import style0 from "./CompactEditComplexLookupComponent.vue?vue&type=style&index=0&id=0f54d934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f54d934",
  null
  
)

export default component.exports